import React from 'react'
import './ProductsSection.css'
import DecoIco1 from '../images/svg/decoIco1.svg'
import DecoIco2 from '../images/svg/decoIco2.svg'
import DecoIco3 from '../images/svg/decoIco3.svg'
import BlogomatFoto from '../images/webp/blogomat-hp-2.webp'
import ChatbotFoto from '../images/webp/chatbot-hp-2.webp'
import { Link } from 'react-router-dom'



function ProductsSection() {
    return (
        <div className='products-section'>
            <div className='first-title-div'>
                <div className='col-one'>
                    <h3 className='first-title'>
                        Unleash the power<br /> of AI
                    </h3>
                </div>
                <div className='col-two'>
                    <p>
                        Less manual work. More output. <br />Marketing that runs itself.
                    </p>
                </div>
                <div className='col-three'>
                    <img src={DecoIco1} alt='decoration icon' className='deco-icon deco-icon1' />
                    <img src={DecoIco2} alt='decoration icon' className='deco-icon deco-icon2' />
                    <img src={DecoIco3} alt='decoration icon' className='deco-icon deco-icon3' />
                </div>
            </div>
            <div className='client-description1'>
                <div className='client-text'>
                    <h4 className='client-name'>Blogomat 360°</h4>
                    <p className='desc-big'>
                        Turn your content into a growth system — powered by AI and automation.
                    </p>
                    <p className='desc-small'>
                        Blogomat 360° plans, writes, and publishes content that matches your strategy and stays consistent. It connects topics, internal linking, and SEO structure into one repeatable workflow — so your traffic grows while your team focuses on bigger moves.
                    </p>
                    
                    <Link to='/blogomat360' className='check-it-now-link'>
                        Check it now →
                    </Link>


                </div>
                <div className='client-foto'>
                    <img src={BlogomatFoto} alt='blogomat 360' />

                </div>
            </div>

            <div className='client-description2'>
                <div className='client-foto'>
                    <img src={ChatbotFoto} alt='chatbot 360' />

                </div>
                <div className='client-text'>
                    <h4 className='client-name'>Chatbot 360°</h4>
                    <p className='desc-big'>
                        Turn visits into conversations — and conversations into customers.
                    </p>
                    <p className='desc-small'>
                        Chatbot360 answers questions instantly, qualifies leads, and <br />
                        guides people to the right offer — 24/7. It reduces manual<br /> support, improves conversion, and keeps your sales pipeline<br /> moving even when your team is offline.
                    </p>

                       <Link to='/chatbot360' className='check-it-now-link'>
                        Check it now →
                    </Link>
                </div>
            </div>

            

        </div>
    )
}

export default ProductsSection
